import { render } from "./RtxRoomPlanB2C.vue?vue&type=template&id=348f9102&scoped=true"
import script from "./RtxRoomPlanB2C.vue?vue&type=script&lang=js"
export * from "./RtxRoomPlanB2C.vue?vue&type=script&lang=js"

import "./RtxRoomPlanB2C.vue?vue&type=style&index=0&id=348f9102&scoped=true&lang=css"

import exportComponent from "D:\\curProject\\newTrip\\client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-348f9102"]])

export default __exports__